// removed by extract-text-webpack-plugin
module.exports = {"whyCardlessEmiBackgroundContainer":"whyCardlessEmiBackgroundContainer__196lM","whyCardlessEmiContainer":"whyCardlessEmiContainer__XAos-","outerContainer":"outerContainer__2dhQr","heading":"heading__1Rtov","headingCardless":"headingCardless__3okZ5","card":"card__7NRiw","headingCard":"headingCard__cXe6e","headingCardMobile":"headingCardMobile__2IsM-","headingMobile":"headingMobile__CxTFD","headingCardlessMobile":"headingCardlessMobile__3Ax8H"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVD/whyCardlessEmi/style.css
// module id = 0FYr
// module chunks = 380